import { useCallback, useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
import { debounce } from "lodash";
import ClipLoader from "react-spinners/ClipLoader";
import AsyncSelect from "react-select/async";
import { UserContext } from "../../../../Context/UserContext";
import { BaseURL } from "../../../../Reusable/BaseURL";

export const DirectGPUpdItemByDivisionSelect = ({
  changingSelect,
  setChangingSelect,
  selectedOption,
  setSelectedOption,
  divisionLabel,
  setEmpty,
}) => {
  const {
    darkTheme,
    loginData,
    setIndentCreateItemId4Upd,
    indentCreateItemId4Upd,
  } = useContext(UserContext);

  const [options, setOptions] = useState([]);
  // const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // async function getItemByDivision() {
  //   setIsLoading(true);
  //   const response = await fetch(
  //     // `${BaseURL}/purchase/indent/itemsbydivision?division=${
  //     //   divisionLabel.label ? divisionLabel.label : divisionLabel
  //     // }`,
  //     `${BaseURL}/items?q=`,
  //     {
  //       method: "GET",
  //       headers: {
  //         Accept: "application/json",
  //         Authorization: `Bearer ${loginData.token}`,
  //       },
  //     }
  //   );
  //   const data = await response.json();
  //   const transformedOptions = data.data.data.map((item) => ({
  //     value: item.id,
  //     label: item.item_name,
  //     unit: item.unit,
  //     division: item.division,
  //     hsn_no: item.hsn_no,
  //   }));
  //   setOptions(transformedOptions);
  //   if (data.status === true || data.status === false) {
  //     setIsLoading(false);
  //   }
  // }
  // useEffect(() => {
  //   getItemByDivision();
  // }, [divisionLabel.label]);

  // Fetch initial data on component mount
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        // console.log({ divisionLabel, selectedOption})
        const response = await fetch(
          `${BaseURL}/items?q=${
            selectedOption.label ? selectedOption.label : selectedOption
          }`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${loginData.token}`,
            },
          }
        );
        const data = await response.json();
        const myFilter = data.data.data.filter(
          (item) => item.item_name === selectedOption
        );
        const transformedOptions = myFilter.map((item) => ({
          value: item.id,
          label: item.item_name,
          unit: item.unit,
          division: item.division,
          hsn_no: item.hsn_no,
        }));
        const myFind = transformedOptions.find(
          (item) => item.label === selectedOption
        );
        if (myFind) {
          setSelectedOption(myFind);
        }
        //   console.log("myFilterDivi::", myFilter)
        // console.log("myMapDivi::", transformedOptions)
        // console.log("myFindDivi::", myFind)

        // if (myFind.division === divisionLabel) {
        setIndentCreateItemId4Upd(myFind);
        // }

        // console.log("myfinditemId", indentCreateItemId4Upd.value)
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    fetchInitialData();
    setChangingSelect(false);
  }, [changingSelect]);

  // Function to load options based on user input
  const loadOptions = (inputValue, callback) => {
    fetch(`${BaseURL}/items?q=${inputValue}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const options = data.data.data.map((item) => ({
          value: item.id,
          label: item.item_name,
          unit: item.unit,
          division: item.division,
          hsn_no: item.hsn_no,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        callback([]);
      });
  };
  const debouncedLoadOptions = debounce(loadOptions, 400);

  // Function to fetch data based on input
  // const fetchData = useCallback(
  //   debounce(async (input) => {
  //     if (input === "") {
  //       getItemByDivision();
  //       setEmpty("");
  //     } else {
  //       getItemByDivision();
  //     }

  // else {
  //   // Fetch data based on input
  //   const API_URL = `${BaseURL}/purchase/indent/divisions?q=${input}`;
  //   try {
  //     const response = await fetch(API_URL, {
  //       method: "GET",
  //       headers: {
  //         Accept: "application/json",
  //         Authorization: `Bearer ${loginData.token}`,
  //       },
  //     });
  //     const data = await response.json();
  //     const transformedOptions = data.data.data.map((item) => ({
  //       value: item.id,
  //       label: item.item_name,
  //     }));
  //     setOptions(transformedOptions);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // }

  //   }, 300),
  //   []
  // );

  // Handle input change
  // const handleInputChange = (newValue) => {
  //   setInputValue(newValue);
  //   // fetchData(newValue);
  //   // fetchData(divisionLabel.label? divisionLabel.label : divisionLabel || newValue);
  // };

  // Handle option select
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  // Custom styling
  const customStyles = {
    // loading style
    // menuList: (provided) => ({
    //   ...provided,
    //   display: "flex",
    //   justifyContent: "center",
    //   alignItems: "center",
    //   minHeight: "50px",
    //   flexDirection: "column",
    //   textTransform: "uppercase",
    // }),

    container: (provided) => ({
      ...provided,
      width: "100%",
      margin: "0 auto",
      color: `${darkTheme ? "white" : "black"}`,
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      borderColor: "none",
      boxShadow: "none",
      "&:hover": {
        borderColor: "none",
      },
      borderRadius: "8px",
      border: "none",
      padding: "0 2px",
      color: `${darkTheme ? "#fffa" : "#111a"}`,
      textTransform: "uppercase",
      border: `${darkTheme ? "1px solid #6B7280" : "1px solid #6B7280"}`,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      textTransform: "uppercase",
      border: "1px solid #6B7280",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2a60a0"
        : state.isFocused
        ? "#0ffa"
        : darkTheme
        ? "#374151"
        : "#ffff",
      color: state.isSelected ? "white" : "black",
      "&:active": {
        backgroundColor: "#aad",
        color: "white",
      },
      padding: "4px 10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: `${darkTheme ? "white" : "black"}`,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: `${darkTheme ? "white" : "black"}`,
      fontWeight: "400",
      fontSize: "14px",
      textTransform: "uppercase",
    }),
  };

  const MenuList = (props) => {
    const { isLoading, children } = props;
    return (
      <components.MenuList {...props}>
        {isLoading ? (
          <div
            style={
              {
                // display: "flex",
                // flexDirection: "row",
                // justifyContent: "center",
                // alignItems: "center",
                // height: "100%",
              }
            }
          >
            <ClipLoader color="#000" loading={isLoading} size={30} />
          </div>
        ) : (
          children
        )}
      </components.MenuList>
    );
  };

  return (
    <AsyncSelect
      // onFocus={getItemByDivision}
      styles={customStyles}
      cacheOptions
      loadOptions={debouncedLoadOptions}
      defaultOptions
      // options={options}
      // onInputChange={handleInputChange}
      // inputValue={inputValue}
      onChange={handleChange}
      value={selectedOption}
      // defaultValue={defValue}
      placeholder="Select"
      isLoading={isLoading}
      // components={{
      //   MenuList: (props) => <MenuList {...props} isLoading={isLoading} />,
      // }}
      closeMenuOnSelect={true}
      className="react-select-container"
      classNamePrefix="react-select"
      isClearable
      // isDisabled={!divisionLabel}
    />
  );
};
